import AdminCrudPage from "../Commaon/AdminCrudPage";

const PermissionsList = () => (
  <AdminCrudPage
    title="Permissions"
    listPath="/admin/permission"
    addPath="/admin/permission"
    editPath={(id) => `/admin/permission/${id}`}
    deletePath={(id) => `/admin/permission/${id}`}
    getByIdPath={(id) => `/admin/permission/${id}`}
    statusPath={(id) => `/admin/permission/${id}`}
    addButtonLabel="Add Permission"
    fields={[
      { name: "name", label: "Name" },
      { name: "action", label: "Action" },
      { name: "module", label: "Module" },
      { name: "description", label: "Description", type: "textarea" },
    ]}
    columns={[
      { key: "name", label: "Name" },
      { key: "action", label: "Action" },
      { key: "module", label: "Module" },
      { key: "description", label: "Description" },
    ]}
    searchFields={["name", "action", "module", "description"]}
  />
);

export default PermissionsList;
